<template>
  <div>
    <div class="admin-home mt-5 pt-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="text">
              <h2 class="h1">Welcom To Admin Page</h2>
              <p class="lead">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Impedit ipsum iusto at! Quas et nemo odio veritatis! Commodi exercitationem veniam corporis facilis ea tempora, optio, ad labore fugit, voluptatum aperiam?</p>
            </div>
          </div>
          <div class="col-md-6">
              <div class="image">
                  <img src="../../assets/app/images/login.png" alt="admin-image">
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "adminHome"
};
</script>
